import { HumanReadableLanguagesForCategories } from 'src/types';

export interface LanguageOption {
  label: string;
  value: string;
  isDefault?: boolean;
}

const categoryLanguageLabels = Object.fromEntries(
  HumanReadableLanguagesForCategories,
) as Record<string, string>;

function lookupHumanReadableLanguage(code: string): string | undefined {
  if (code in categoryLanguageLabels) {
    return categoryLanguageLabels[code];
  }
  const languageSubtag = code.split('-')[0];
  if (languageSubtag !== code && languageSubtag in categoryLanguageLabels) {
    return categoryLanguageLabels[languageSubtag];
  }
  return undefined;
}

export function getLanguageDisplayLabel(code: string): string {
  const trimmed = code.trim();
  if (!trimmed) return '';

  const fromCategoryConfig = lookupHumanReadableLanguage(trimmed);
  if (fromCategoryConfig) return fromCategoryConfig;

  return trimmed;
}

export function toLanguageOption(
  value: string,
  isDefault?: boolean,
): LanguageOption {
  return {
    value,
    label: getLanguageDisplayLabel(value),
    ...(isDefault !== undefined ? { isDefault } : {}),
  };
}

export const sortLanguageOptionsByLabel = (
  languages: LanguageOption[],
): LanguageOption[] =>
  [...languages].sort((a, b) => {
    const byLabel = a.label.localeCompare(b.label);
    if (byLabel !== 0) return byLabel;
    return a.value.localeCompare(b.value);
  });

export const LANGUAGE_OPTIONS: LanguageOption[] = sortLanguageOptionsByLabel(
  HumanReadableLanguagesForCategories.map(([value, label]) => ({
    value,
    label,
  })),
);
